import CLIDownload from "../../../../contents/docs/error-tracking/_snippets/cli/download.mdx";
import CLIAuthenticate from "../../../../contents/docs/error-tracking/_snippets/cli/authenticate.mdx";
import CLIInject from "../../../../contents/docs/error-tracking/_snippets/cli/inject.mdx";
import CLIUpload from "../../../../contents/docs/error-tracking/_snippets/cli/upload.mdx";
import StepVerifySourceMapUpload from "../../../../contents/docs/error-tracking/upload-source-maps/_snippets/step-verify-source-map-upload.mdx";
import * as React from 'react';
export default {
  CLIDownload,
  CLIAuthenticate,
  CLIInject,
  CLIUpload,
  StepVerifySourceMapUpload,
  React
};